import React from 'react';
import JsPDF from 'jspdf';
import ReactDOMServer from 'react-dom/server';
import { ContainerPdf } from '../styles';

interface GeneratePdf {
  htmlString: string;
  fileName?: string;
}

export const generatePdf = async ({ htmlString, fileName }: GeneratePdf) => {
  const html = ReactDOMServer
    .renderToString(<ContainerPdf dangerouslySetInnerHTML={{ __html: htmlString }} />);

  const doc = new JsPDF({
    format: 'a4',
    unit: 'mm',
  });

  await doc.html(html, {
    width: 160,
    margin: 20,
    windowWidth: 500,
    callback(doc) {
      doc.save(fileName && `${fileName}.pdf`);
    },
  });
};
